export const MIN_TABS_ITEMS_FOR_COLS = 5;

export const TABS_DESKTOP_SCROLL_POSITION = 310;
export const TABS_TABLET_SCROLL_POSITION = 445;
export const TABS_MOBILE_SCROLL_POSITION = 490;
